import { render, staticRenderFns } from "./tabExternalProjectSummaryReport.vue?vue&type=template&id=4f131120&scoped=true&"
import script from "./tabExternalProjectSummaryReport.vue?vue&type=script&lang=ts&"
export * from "./tabExternalProjectSummaryReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f131120",
  null
  
)

export default component.exports